const initialStateMobile = {};

export default initialStateMobile;
